import React from 'react'
import PropTypes from 'prop-types'
import { Title, Category, TitleContainer } from './ArticleTitle.style'

const ArticleTitle = ({ category, title }) => (
  <TitleContainer>
    <Category>{category.title}</Category>
    <Title>{title}</Title>
  </TitleContainer>
)

ArticleTitle.propTypes = {
  title: PropTypes.string.isRequired,
  category: PropTypes.shape({
    title: PropTypes.string.isRequired,
  }).isRequired,
}

export default ArticleTitle
